import React from 'react';

const OutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2087 5.16699C30.2087 3.02689 28.4738 1.29199 26.3337 1.29199H5.66699C3.52689 1.29199 1.79199 3.02689 1.79199 5.16699V18.0837C1.79199 20.2238 3.52689 21.9587 5.66699 21.9587H6.95866C7.67202 21.9587 8.25033 21.3804 8.25033 20.667C8.25033 19.9536 7.67202 19.3753 6.95866 19.3753H5.66699C4.95363 19.3753 4.37533 18.797 4.37533 18.0837V10.3337H27.6253V18.0837C27.6253 18.797 27.047 19.3753 26.3337 19.3753H25.042C24.3286 19.3753 23.7503 19.9536 23.7503 20.667C23.7503 21.3804 24.3286 21.9587 25.042 21.9587H26.3337C28.4738 21.9587 30.2087 20.2238 30.2087 18.0837V5.16699ZM27.6253 7.75033V5.16699C27.6253 4.45363 27.047 3.87533 26.3337 3.87533H5.66699C4.95363 3.87533 4.37533 4.45362 4.37533 5.16699V7.75033H27.6253Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2077 5.16699C30.2077 3.02689 28.4728 1.29199 26.3327 1.29199H5.66602C3.52592 1.29199 1.79102 3.02689 1.79102 5.16699V18.0837C1.79102 20.2238 3.52592 21.9587 5.66602 21.9587H6.95768C7.67104 21.9587 8.24935 21.3804 8.24935 20.667C8.24935 19.9536 7.67104 19.3753 6.95768 19.3753H5.66602C4.95265 19.3753 4.37435 18.797 4.37435 18.0837V10.3337H27.6244V18.0837C27.6244 18.797 27.0461 19.3753 26.3327 19.3753H25.041C24.3276 19.3753 23.7493 19.9536 23.7493 20.667C23.7493 21.3804 24.3276 21.9587 25.041 21.9587H26.3327C28.4728 21.9587 30.2077 20.2238 30.2077 18.0837V5.16699ZM27.6244 7.75033V5.16699C27.6244 4.45363 27.0461 3.87533 26.3327 3.87533H5.66602C4.95265 3.87533 4.37435 4.45362 4.37435 5.16699V7.75033H27.6244Z"
      fill="white"
    />
    <path
      d="M17.2913 28.4168C17.2913 29.1302 16.713 29.7085 15.9997 29.7085C15.2863 29.7085 14.708 29.1302 14.708 28.4168V21.1924L13.038 22.8622C12.5336 23.3668 11.7158 23.3668 11.2113 22.8622C10.7069 22.358 10.7069 21.54 11.2113 21.0357L15.0857 17.1694C15.5902 16.6658 16.4073 16.6663 16.9114 17.1703L20.7853 21.0443C21.2898 21.5488 21.2898 22.3665 20.7853 22.8711C20.2809 23.3753 19.463 23.3753 18.9586 22.8711L17.2913 21.2038V28.4168Z"
      fill="white"
    />
  </svg>
);

export default OutIcon;
